module.exports = __webpack_public_path__ + "img/E11.d5a0b41d.svg";